export default __webpack_public_path__ + "static/media/grafema_amcc_05.89d64452.mp4";